import React from 'react';

interface Props {
  title: string;
  definition: string | number | null | React.ReactNode;
}

const DescriptionListItem: React.FC<Props> = ({ title, definition }) => {
  if (!title) {
    return null;
  }
  return (
    <>
      <dt>{title}</dt>
      <dd>
        {definition === null || definition === undefined || definition === ''
          ? '-'
          : definition}
      </dd>
    </>
  );
};

export default React.memo(DescriptionListItem);
